
    import {
        defineComponent,
    } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import { type MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
    import { type AvailableProductTypes } from '../common/types';
    import useProductTypeFilterHotel from '../common/useProductTypeFilterHotel';

    const filtersMappingStoreName = 'mapForFilters';

    export default defineComponent({
        name: 'ProductTypeFilter',
        setup() {
            const availableProductTypes: AvailableProductTypes[] = [{
                type: 'all',
                name: 'Все предложения',
            }, {
                type: 'tourOffer',
                name: 'С авиаперелётом',
            }, {
                type: 'railwayTour',
                name: 'С ж/д',
            }, {
                type: 'hotelOffer',
                name: 'Только отель',
            }];

            const {
                productType,
            } = useState<MapForFiltersState>(filtersMappingStoreName, ['productType']);

            return {
                ...useProductTypeFilterHotel({
                    productType,
                    availableProductTypes,
                }),
                productType,
            };
        },
    });
